export default {
    styleOverrides: {
        root: {
            textTransform: "none",
            fontSize: "14px",
        },
    },
};
